import React from 'react';

export const LoadingWrapper = (props) => {
    return (
        <div ref={props.loaderRef} className="position-relative min-height-100">
            {props.children}
        </div>
    )
};